module.exports = __webpack_public_path__ + "img/business-solutions-card2@2x.1a4d5eb7.png";